import { Box } from '@mui/material';

interface Props {
  children?: React.ReactElement<unknown>;
  color?: 'light' | 'dark'
}

export default function Hr(props: Props) {
  return (
    <Box
      component={'hr'}
      sx={(theme) => ({
        padding: 0,
        margin: 0,
        borderBottomStyle: 'solid',
        color: theme.palette.grey[props.color === 'dark' ? 50 : 900],
        borderColor: theme.palette.grey[props.color === 'dark' ? 50 : 900],
        [theme.breakpoints.up('xs')]: {
          borderBottom: 5,
        },
        [theme.breakpoints.up('md')]: {
          borderBottom: 7,
        },
        [theme.breakpoints.up('lg')]: {
          borderBottom: 10,
        }
      })}
    />
  )
}